import './PageContentHeading.scss';

import PageHeading from 'components/Page/PageHeading';
import React from 'react';

import PageActionsV2 from './PageActionsV2';

interface PageContentHeadingProps {
  title?: string;
  actions?: React.ReactNode; // Pass actions inside react fragment to not broke styles
}

const PageContentHeading = ({ title, actions }: PageContentHeadingProps) => {
  return (
    <div
      className={`PageContentHeading${!actions ? ' withoutActions' : ''}${
        !title ? ' withoutTitle' : ''
      }`}
    >
      {title && <PageHeading title={title} />}
      {actions && <PageActionsV2 actions={actions} />}
    </div>
  );
};

export default PageContentHeading;
